require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconClock.tsx
var IconClock_exports = {};
__export(IconClock_exports, {
  default: () => IconClock_default
});
module.exports = __toCommonJS(IconClock_exports);

// src/assets/monochrome/clock.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgClock = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2 10C17.2 13.9764 13.9764 17.2 10 17.2C6.02355 17.2 2.8 13.9764 2.8 10C2.8 6.02355 6.02355 2.8 10 2.8C13.9764 2.8 17.2 6.02355 17.2 10ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM12.6996 9.1001H10.8996V5.5001C10.8996 5.2614 10.8048 5.03248 10.636 4.8637C10.4672 4.69492 10.2383 4.6001 9.99961 4.6001C9.76091 4.6001 9.532 4.69492 9.36321 4.8637C9.19443 5.03248 9.09961 5.2614 9.09961 5.5001V10.0001C9.09961 10.2388 9.19443 10.4677 9.36321 10.6365C9.532 10.8053 9.76091 10.9001 9.99961 10.9001H12.6996C12.9383 10.9001 13.1672 10.8053 13.336 10.6365C13.5048 10.4677 13.5996 10.2388 13.5996 10.0001C13.5996 9.7614 13.5048 9.53248 13.336 9.3637C13.1672 9.19492 12.9383 9.1001 12.6996 9.1001Z", fill: "#676F7E" }) });
var clock_default = SvgClock;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconClock.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconClock = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(clock_default, {}) });
};
IconClock.displayName = "IconClock";
var IconClock_default = IconClock;
